var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11720_7143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 6.66659H13.3333C13.5101 6.66659 13.6797 6.73682 13.8047 6.86185C13.9298 6.98687 14 7.15644 14 7.33325V13.9999C14 14.1767 13.9298 14.3463 13.8047 14.4713C13.6797 14.5963 13.5101 14.6666 13.3333 14.6666H2.66667C2.48986 14.6666 2.32029 14.5963 2.19526 14.4713C2.07024 14.3463 2 14.1767 2 13.9999V7.33325C2 7.15644 2.07024 6.98687 2.19526 6.86185C2.32029 6.73682 2.48986 6.66659 2.66667 6.66659H3.33333V5.99992C3.33333 5.38708 3.45404 4.78025 3.68856 4.21406C3.92308 3.64788 4.26683 3.13343 4.70017 2.70009C5.13351 2.26675 5.64796 1.923 6.21414 1.68848C6.78033 1.45396 7.38716 1.33325 8 1.33325C8.61284 1.33325 9.21967 1.45396 9.78586 1.68848C10.352 1.923 10.8665 2.26675 11.2998 2.70009C11.7332 3.13343 12.0769 3.64788 12.3114 4.21406C12.546 4.78025 12.6667 5.38708 12.6667 5.99992V6.66659ZM11.3333 6.66659V5.99992C11.3333 5.11586 10.9821 4.26802 10.357 3.6429C9.7319 3.01777 8.88406 2.66659 8 2.66659C7.11595 2.66659 6.2681 3.01777 5.64298 3.6429C5.01786 4.26802 4.66667 5.11586 4.66667 5.99992V6.66659H11.3333ZM7.33333 9.33325V11.9999H8.66667V9.33325H7.33333Z",
    fill: "#FCFCFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11720_7143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyPrivate);
export default __webpack_public_path__ + "static/media/key_private.5ac67f3dc8c889d40eab43351760c82d.svg";
export { ForwardRef as ReactComponent };